import { render, staticRenderFns } from "./AmazonServe.vue?vue&type=template&id=763e287d"
import script from "./AmazonServe.vue?vue&type=script&lang=js"
export * from "./AmazonServe.vue?vue&type=script&lang=js"
import style0 from "./AmazonServe.vue?vue&type=style&index=0&id=763e287d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports